import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Transactions from "./pages/Transactions";
import Categories from "./pages/Categories";
import Reports from "./pages/Reports";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import "./styles/Main.css";
import NavBar from "./components/NavBar";
import { UserState } from "./context/UserState";
import { useTheme } from "./context/ThemeContext";

export default function App() {
  const { theme } = useTheme();
  return (
    <div className={`min-h-screen bg-slate-950 text-slate-100 ${theme === "dark" ? "" : "bg-white text-slate-900"}`}>
      <BrowserRouter>
        <UserState>
          <NavBar />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/transactions" element={<Transactions />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </UserState>
      </BrowserRouter>
    </div>
  );
}